import { render, staticRenderFns } from "./BankWithdrawFormOtp.vue?vue&type=template&id=6b366ebe"
import script from "./BankWithdrawFormOtp.vue?vue&type=script&lang=js"
export * from "./BankWithdrawFormOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports